<template>
  <div class="app-card-filter"
       :class="[
         data.color ? 'has-color': '',
         data.active ? 'is-active' : '',
         this.isDate ? 'is-date' : '',
         this.isHall ? 'is-hall' : ''
         ]"
       :style="data.color ? `--color: ${data.color}` : null"
       :id="data.id">
    <label class="app-card-filter__label">
      <input :key="data.value"
      :type="type || 'radio'"
      :name="data.name"
      :id="data.id"
      :value="data.value"
             @change="$emit('change', $event)" :checked="data.active">
    </label>
    <div class="app-card-filter__inner">
      <div class="app-card-filter__icon"
           :style="data.color ? `--color: ${data.color}` : null" v-if="data.color">
        <div class="app-card-filter__icon-pattern">
          <div class="app-card-filter__icon-circle"></div>
        </div>
      </div>
      <div class="app-card-filter__text" v-if="data.text">{{ data.text }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AppCardFilter',
  components: {},

  props: ['data', 'type', 'isDate', 'isHall'],
  data() {
    return {
    };
  },
};
</script>

<style lang="scss">
  @import "app-card-filter";
</style>
